import FormGenerarSuscripciones from './suscripciones/generacion/FormGenerarSuscripciones.vue';
import FraccionarCobroForm from './cobros/FraccionarCobroForm.vue';
import SelectorModalidad from './SelectorModalidad.vue';
import SelectorServicio from './SelectorServicio.vue';
import SelectorModalidadInfo from './SelectorModalidadInfo.vue';

export default {
  install: (app, _options) => {
    app
      .component('SelectorModalidad', SelectorModalidad)
      .component('SelectorModalidadInfo', SelectorModalidadInfo)
      .component('SelectorServicio', SelectorServicio)
      .component('FormGenerarSuscripciones', FormGenerarSuscripciones)
      .component('FraccionarCobroForm', FraccionarCobroForm);
  },
};
